import api from './api';

const invoiceApi = {
  // Get invoice data
  getInvoice: (id) => api.get(`/invoices/${id}`),
  
  // Download PDF invoice
  downloadPDF: (id) => {
    return api.get(`/invoices/${id}/pdf`, {
      responseType: 'blob'
    });
  }
};

export default invoiceApi;

